<div class="sh-form-tag-list">
  <div class="sh-form-tag-list__input">
    <ng-container *ngTemplateOutlet="inputField"></ng-container>
  </div>
  <ng-container *ngTemplateOutlet="tagList"></ng-container>
  <ng-container *ngTemplateOutlet="errorMessages"></ng-container>
</div>

<ng-template #inputField>
  <div class="sh-input-field-with-action">
    <div class="sh-input-field-with-action__input">
      <med-thesaurus-search
        #search
        [thesaurusSearchControl]="thesaurusSearchControl"
        [thesaurusDefDottedKey]="thesaurusDefDottedKey"
        [multiple]="multiple"
        [enableSuggestions]="enableSuggestions"
        [indeterminateMsg]="'general.different-values' | translate"
        [disabledMsg]="disabledMsg"
        [setValue]="synchronizeConceptSelection$ | async"
        (selectedConcept)="onLookupSelection($event)"
        (suggestion)="onSuggestion($event)"
      ></med-thesaurus-search>
    </div>
    @if (selectValuesActionItem$ | async; as selectValuesActionItem) {
      <sh-action-item
        class="sh-input-field-with-action__action"
        [item]="selectValuesActionItem"
        >
      </sh-action-item>
    }
  </div>
</ng-template>

<ng-template #tagList>
  @if ((tags$ | async)?.options.length > 0 || (this.suggestedConcepts$ | async)?.length > 0) {
    <med-thesaurus-tag-list
      [id]="id"
      [disabled]="disabled"
      [multiple]="multiple"
      [placeholderMsg]="placeholderMsg"
      [tags]="tags$ | async"
      [suggestions]="suggestedConcepts$ | async"
      (valueRemoved)="removeValue($event)"
      (suggestionRemoved)="removeSuggestion($event)"
      >
    </med-thesaurus-tag-list>
  } @else {
    <p class="sh-clear-margin">{{ placeholderMsg }}</p>
  }
</ng-template>

<ng-template #errorMessages>
  @if (suggestionErrorMsg$ | async; as suggestionErrorMsg) {
    <p [style]="'color: red;'" class="sh-form-group__feedback">
      <sh-html-parser [message]="suggestionErrorMsg"></sh-html-parser>
    </p>
  }
  @if ((isIndeterminate$ | async) && multiple) {
    <p class="sh-form-group__feedback">{{ indeterminateMsg }}</p>
  }
</ng-template>

